<template>
  <WdsStack
    gap-xs
    direction-column
    justify-space-between
    class="tw-bg-true-gray-100 tw-rounded tw-grow tw-p-2"
  >
    <WdsText lg class="tw-font-medium tw-text-gray-600">{{ $t('Rate') }}</WdsText>
    <WdsText>
      <span class="tw-font-semibold">{{ formatContractRate({ currency, rate, rateType }) }}</span>
    </WdsText>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { formatContractRate } from '@/utils/hireContract'

defineProps<{
  currency: string
  rate: string | number
  rateType: string | null | undefined
}>()
</script>
